// 게시판 화면 표시용 순수 함수. 본문은 HTML로 해석하지 않고, http(s) 주소만 링크 조각으로 나눈다.
const SEOUL_DATE = new Intl.DateTimeFormat('ko-KR', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit' })

/** 게시 시작 시각(이관 글의 원래 작성일)이 있으면 그 날짜를, 없으면 작성 시각을 YYYY.MM.DD(한국 시간)로 보여 준다. */
export function boardDate(post) {
  const value = post?.publishFrom || post?.createdAt
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const parts = Object.fromEntries(SEOUL_DATE.formatToParts(date).map(part => [part.type, part.value]))
  return `${parts.year}.${parts.month}.${parts.day}`
}

// 한글 등 ASCII 밖 문자는 주소에 넣지 않는다('http://www.techedu.kr에 접속'의 조사가 링크에 붙지 않게). 한글 경로는 %인코딩된 주소만 링크한다.
const URL_PATTERN = /https?:\/\/[^\s<>"'\u0080-￿]+/g
/** 평문을 [{ text }] 또는 [{ href, text }] 조각으로 나눈다. http/https 외의 스킴은 링크로 만들지 않는다. */
export function linkTokens(text) {
  const value = String(text ?? ''), tokens = []
  let last = 0
  for (const match of value.matchAll(URL_PATTERN)) {
    let url = match[0]
    // 문장 끝 구두점과 감싸는 괄호는 주소에서 뺀다. 주소 안에서 짝이 맞는 괄호는 남긴다.
    while (/[).,\]]$/.test(url) && !(url.endsWith(')') && (url.match(/\(/g) || []).length >= (url.match(/\)/g) || []).length)) url = url.slice(0, -1)
    const start = match.index
    if (start > last) tokens.push({ text: value.slice(last, start) })
    try { const parsed = new URL(url); if (!['http:', 'https:'].includes(parsed.protocol)) throw new Error('scheme'); tokens.push({ href: parsed.href, text: url }) } catch { tokens.push({ text: url }) }
    last = start + url.length
  }
  if (last < value.length) tokens.push({ text: value.slice(last) })
  return tokens
}

/** FAQ 제목 앞의 [분류] 표시를 나눈다. 분류가 없으면 category 는 빈 문자열이다. */
export function faqCategory(title) {
  const value = String(title ?? ''), match = /^\[([^\]\n]{1,20})\]\s*/.exec(value)
  return match && value.length > match[0].length ? { category: match[1].trim(), title: value.slice(match[0].length) } : { category: '', title: value }
}

/** 파일 크기를 KB/MB 로 줄여 보여 준다. */
export function fileSize(bytes) {
  const value = Number(bytes)
  if (!Number.isFinite(value) || value < 0) return ''
  if (value < 1024) return `${value}B`
  if (value < 1024 * 1024) return `${Math.round(value / 1024)}KB`
  return `${(value / (1024 * 1024)).toFixed(1)}MB`
}

/** 현재 쪽이 들어 있는 10쪽 묶음의 쪽 번호와 앞·뒤 묶음 이동 가능 여부. */
export function pageWindow(current, total, size, width = 10) {
  const last = Math.max(1, Math.ceil(Math.max(0, Number(total) || 0) / size)), page = Math.min(Math.max(1, current), last)
  const first = Math.floor((page - 1) / width) * width + 1, end = Math.min(last, first + width - 1)
  return { pages: Array.from({ length: end - first + 1 }, (_, index) => first + index), last, previous: first > 1 ? first - 1 : null, next: end < last ? end + 1 : null }
}
